import { InjectionToken, ModuleWithProviders, Provider } from '@angular/core';
import { ThemeService, FakeThemeService } from './theme.service';
import { ThemeLoaderService } from './theme-loader.service';
export var THEME_TOKEN = new InjectionToken('Theme Token');
var ThemeName = /** @class */ (function () {
    function ThemeName(themeService) {
        this.themeService = themeService;
    }
    Object.defineProperty(ThemeName.prototype, "themeId", {
        get: function () {
            return this.themeService.currentTheme.themeId;
        },
        enumerable: true,
        configurable: true
    });
    return ThemeName;
}());
export { ThemeName };
export function themeConfigFactory(themeService) {
    return new ThemeName(themeService);
}
var ThemeModule = /** @class */ (function () {
    function ThemeModule() {
    }
    ThemeModule.forRoot = function (config) {
        return {
            ngModule: ThemeModule,
            providers: [
                config.themeLoader || { provide: ThemeService, useClass: FakeThemeService },
                {
                    provide: ThemeName,
                    useFactory: themeConfigFactory,
                    deps: [ThemeService]
                },
                ThemeLoaderService
            ]
        };
    };
    return ThemeModule;
}());
export { ThemeModule };
